/* NeuroPulse · página Track your order (gerado de previa/paginas/track.html por tema/converter_paginas.py) */
/* ---------- TRACK YOUR ORDER (módulo "track" do np-paginas.js; autocontido, sem dependências) ----------
   Campo só do número de rastreio · normaliza (tira espaços e hífens, maiúsculas; tira o prefixo de roteamento
   420+CEP do USPS; aceita colar o link de rastreio inteiro) · reconhece a transportadora pelo formato ·
   carrega o 17TRACK SÓ no clique (https://www.17track.net/externalcall.js, YQV5.trackSingle) · plano B se o
   17TRACK não abrir em 6 s (bloqueador, rede do trabalho, Cloudflare): link da transportadora + t.17track.net.
   Privacidade: o número nunca vai para a URL, cookies, localStorage, analytics nem para a Shopify; só sai para o
   17TRACK (iframe e link) ou para a transportadora (link em nova aba, rel="noopener noreferrer").
   Um link vindo do e-mail de envio com #nums=… ou ?nums=… só PREENCHE o campo (não busca sozinho) e o número
   é tirado da barra de endereço na mesma hora.
   Atenção (achado no build): o trackSingle do 17TRACK lê YQ_ContainerId. A Storyelle e a SteadyWave passam
   YQ_ElementId (que só existe no trackSingleF1/F2); com isso o externalcall.js quebra (getElementById(undefined))
   e as duas lojas caem sempre no plano B. Aqui vai YQ_ContainerId, conferido no externalcall.js de 2026-10-09. */
(function(){
  'use strict';
  var root = document.querySelector('[data-npp-tk]');
  if (!root) return;
  var $ = function(s){ return root.querySelector(s); };
  var card = $('[data-npp-tk-card]'), form = $('[data-npp-tk-form]'), input = $('[data-npp-tk-input]'), field = $('[data-npp-tk-field]'),
      btn = $('[data-npp-tk-btn]'), btnT = $('[data-npp-tk-btn-t]'), guessEl = $('[data-npp-tk-guess]'), guessT = $('[data-npp-tk-guess-t]'), wpBtn = $('[data-npp-tk-where]'), wp = $('[data-npp-tk-wp]'),
      msg = $('[data-npp-tk-msg]'), load = $('[data-npp-tk-load]'), alt = $('[data-npp-tk-alt]'), res = $('[data-npp-tk-res]'),
      resNum = $('[data-npp-tk-num]'), resC = $('[data-npp-tk-carrier]'), resCa = $('[data-npp-tk-carrier-a]'), box = $('[data-npp-tk-box]');
  if (!form || !input || !box) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T17 = 'https://t.17track.net/en#nums=';

  /* Transportadoras, do formato mais específico para o mais genérico (o 1.º que bate vence).
     Formatos pesquisados em 2026-10-09 (documentação das transportadoras, 17TRACK, ParcelMonitor, Ship24);
     conferir com números reais na QA. Testados sobre o número já normalizado (só A-Z e 0-9).
     UPS         1Z + 6 alfanum. (conta) + 2 (serviço) + 8 (pacote + dígito verificador) = 18 .... ^1Z[0-9A-Z]{16}$
     YunExpress  YT + 16 dígitos (ex.: YT2405921001234567) ................................. ^YT\d{16}$
     4PX         4PX + 10 a 16 dígitos + CN (ex.: 4PX3001234567890CN) ....................... ^4PX\d{10,16}CN$
     Cainiao     LP + 12 a 16 dígitos (AliExpress Standard, ex.: LP00123456789012) ......... ^LP\d{12,16}$
                 CN + 2 a 4 letras + 9 ou mais dígitos (Cainiao Global) ..................... ^CN[A-Z]{2,4}\d{9,}$
     China Post  padrão UPU S10: 2 letras + 9 dígitos + CN (ePacket LX/LY/LZ, registrada RR/RB,
                 EMS E_, Small Packet U_) ............................................... ^[A-Z]{2}\d{9}CN$
     USPS        IMpb 20 a 22 dígitos começando com 91 a 95 (9400 Ground Advantage, 9205 Priority,
                 9270 Priority Express, 9300/9303 com assinatura) ........................... ^9[1-5]\d{18,20}$
                 Certified Mail, 20 dígitos ........................................... ^(70|23|03)\d{18}$
                 S10 internacional saindo dos EUA: 2 letras + 9 dígitos + US .................. ^[A-Z]{2}\d{9}US$
                 (o código de barras com 420 + CEP de 5 ou 9 dígitos na frente é limpo antes, na normalização)
     FedEx       12 dígitos (Express), 15 (Ground), 20 (Ground Economy), 96 + 20 (Ground SSCC) .. ^(\d{12}|\d{15}|\d{20}|96\d{20})$
     DHL         Express: 10 dígitos ................................................... ^\d{10}$
                 eCommerce: GM, LX ou RX + 10 a 20 dígitos (sem o CN do fim) .................. ^(GM|LX|RX)\d{10,20}$
     Conflitos resolvidos pela ordem: o S10 com CN (China Post) vem antes do LX da DHL; o USPS 9x de 20 a 22
     dígitos vem antes do FedEx de 20; o resto (formato desconhecido) fica só com o 17TRACK. */
  var CARRIERS = [
    { id: 'ups',       name: 'UPS',        site: 'ups.com',      url: 'https://www.ups.com/track?loc=en_US&tracknum=',               re: [/^1Z[0-9A-Z]{16}$/] },
    { id: 'yunexpress',name: 'YunExpress', site: 'yuntrack.com', url: 'https://www.yuntrack.com/parcelTracking?id=',                 re: [/^YT\d{16}$/], intl: true },
    { id: '4px',       name: '4PX',        site: '4px.com',      url: 'https://track.4px.com/#/result/0/',                           re: [/^4PX\d{10,16}CN$/], intl: true },
    { id: 'cainiao',   name: 'Cainiao',    site: 'cainiao.com',  url: 'https://global.cainiao.com/newDetail.htm?mailNoList=',        re: [/^LP\d{12,16}$/, /^CN[A-Z]{2,4}\d{9,}$/], intl: true },
    { id: 'chinapost', name: 'China Post', site: '17track.net',  url: T17,                                                           re: [/^[A-Z]{2}\d{9}CN$/], intl: true },
    { id: 'usps',      name: 'USPS',       site: 'usps.com',     url: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=',       re: [/^9[1-5]\d{18,20}$/, /^(70|23|03)\d{18}$/, /^[A-Z]{2}\d{9}US$/] },
    { id: 'fedex',     name: 'FedEx',      site: 'fedex.com',    url: 'https://www.fedex.com/fedextrack/?trknbr=',                   re: [/^\d{12}$/, /^\d{15}$/, /^\d{20}$/, /^96\d{20}$/] },
    { id: 'dhl',       name: 'DHL',        site: 'dhl.com',      url: 'https://www.dhl.com/global-en/home/tracking.html?submit=1&tracking-id=', re: [/^\d{10}$/, /^(GM|LX|RX)\d{10,20}$/] }
  ];
  function carrierFor(n){
    for (var i = 0; i < CARRIERS.length; i++) for (var j = 0; j < CARRIERS[i].re.length; j++) if (CARRIERS[i].re[j].test(n)) return CARRIERS[i];
    return null;
  }
  function linkFor(c, n){ return c.url + encodeURIComponent(n); }

  /* número colado como link inteiro (do e-mail): tira o parâmetro de rastreio */
  function fromLink(t){
    var m = t.match(/[?&#](?:tLabels|tracknum|trknbr|tracking-id|tracking_number|trackingNumber|tracking|nums|mailNoList|id)=([A-Za-z0-9]{8,40})/i);
    if (m) return m[1];
    m = t.match(/#\/result\/\d+\/([A-Za-z0-9]{8,40})/);
    return m ? m[1] : null;
  }
  /* classifica o que o cliente colou: vazio · email · pedido · invalido · ok (com o número limpo e a transportadora) */
  function classify(raw){
    var t = String(raw || '').trim();
    if (!t) return { k: 'vazio' };
    if (/^https?:\/\//i.test(t)) { var u = fromLink(t); if (u) t = u; }
    if (t.indexOf('@') > -1) return { k: 'email' };
    var n = t.replace(/[\s ‐-―-]+/g, '').toUpperCase();
    if (n.charAt(0) === '#' || /^\d{4,6}$/.test(n)) return { k: 'pedido' };
    if (n.length < 8 || n.length > 40 || !/\d/.test(n) || /[^A-Z0-9]/.test(n)) return { k: 'invalido' };
    n = n.replace(/^420(?:\d{5}|\d{9})(?=9[1-5]\d{18,20}$)/, '');
    return { k: 'ok', num: n, c: carrierFor(n) };
  }

  var MSG = {
    vazio: 'Paste your tracking number first. It\'s in your shipping email.',
    invalido: 'That doesn\'t look like a tracking number. Copy the whole thing from your shipping email and try again.',
    pedido: 'That looks like an order number. This box needs the tracking number, which is in your shipping email.',
    email: 'That\'s an email address. This box only takes a tracking number.'
  };
  var AGAIN = '<button class="npp-tk__again" type="button" aria-label="Clear the field and track another number" data-npp-tk-again>Track another number</button>';

  function topOffset(){ return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nph-h')) || 0) + 20; }
  function go(el){
    if (!el) return;
    var r = el.getBoundingClientRect(), off = topOffset();
    if (r.top >= off && r.top < innerHeight * 0.7) return;           /* já está à vista */
    scrollTo({ top: r.top + scrollY - off, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* reconhecimento ao digitar: o nome da transportadora aparece em texto, com o check, no fim do campo
     (as parceiras internacionais só aparecem quando o número bate com o formato delas: o FATOS manda não informar origem) */
  function guess(c){
    guessEl.hidden = !c; guessT.textContent = c ? c.name : '';
  }
  function clearMsg(){
    msg.innerHTML = ''; field.classList.remove('is-bad'); input.removeAttribute('aria-invalid');
  }
  function say(kind){
    clearMsg();
    field.classList.add('is-bad');
    if (kind === 'invalido') input.setAttribute('aria-invalid', 'true');
    /* no quadro seguinte: o leitor de tela anuncia de novo mesmo que a mensagem se repita */
    requestAnimationFrame(function(){
      msg.innerHTML = '<svg class="npp-tk__msg-ic" aria-hidden="true"><use href="#i-xc"/></svg><span class="npp-tk__msg-tx"><span>' + MSG[kind] +
        '</span> <button class="npp-tk__msg-a" type="button" data-npp-tk-open-wp>Where do I find my tracking number?</button></span>';
    });
    if (kind === 'vazio') input.focus();
  }
  function busy(on){
    btn.classList.toggle('is-busy', on);
    btn.setAttribute('aria-disabled', on ? 'true' : 'false');
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btnT.textContent = on ? 'Finding your package…' : 'Find my package';
    btn.setAttribute('aria-label', on ? 'Finding your package…' : 'Find my package by tracking number');
    load.textContent = on ? 'Looking up your tracking number. This takes a few seconds.' : '';
    load.classList.toggle('is-on', on);
  }
  function clearOut(){
    alt.innerHTML = ''; alt.classList.remove('is-on');
    res.hidden = true; box.innerHTML = '';
  }
  function showResult(num, c){
    resNum.textContent = num;
    var own = !!c && c.url !== T17;
    resC.hidden = !own;
    if (own) { resCa.href = linkFor(c, num); resCa.textContent = 'Open on ' + c.site; resCa.setAttribute('aria-label', 'Open on ' + c.site + ' (opens in a new tab)'); }
    res.hidden = false;
  }
  function btnLink(href, label, main){
    return '<a class="npp-btn' + (main ? '' : ' npp-btn--line') + ' npp-tk__alt-btn" href="' + href + '" target="_blank" rel="noopener noreferrer" aria-label="' + label +
      ' (opens in a new tab)">' + label + '<svg class="npp-arrow" aria-hidden="true"><use href="#i-arrow"/></svg></a>';
  }
  function showAlt(num, c){
    var t17 = T17 + encodeURIComponent(num), html;
    if (c) {
      html = '<p class="npp-tk__alt-t">Looks like a ' + c.name + ' number.</p><div class="npp-tk__alt-a">' + btnLink(linkFor(c, num), 'Open on ' + c.site, true) +
        (c.url !== T17 ? btnLink(t17, 'Open on 17TRACK', false) : '') + '</div>';
    } else {
      html = '<p class="npp-tk__alt-t">Live tracking didn\'t load here. Some ad blockers and work networks stop it, but your number still works. Open it directly:</p>' +
        '<div class="npp-tk__alt-a">' + btnLink(t17, 'Open on 17track.net', true) + '</div>' +
        '<p class="npp-tk__alt-s">Or <a class="npp-tk__lnk" href="mailto:support@neuropulsemen.com">email us</a> your order number and we\'ll check it for you.</p>';
    }
    alt.innerHTML = '<span class="npp-disc"><img class="npp-ic" src="https://cdn.shopify.com/s/files/1/0673/3276/7821/files/np-pg-np-ic-caminhao-branco.png?v=1791576160&width=78" alt="" width="26" height="26"></span>' +
      '<div class="npp-tk__alt-bd"><p class="npp-tk__alt-num">' + num + '</p>' + html + AGAIN + '</div>';
    alt.classList.add('is-on');
  }

  /* 17TRACK: injetado só no 1.º clique; desiste em 6 s */
  var el = null;
  function load17(){
    if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') return Promise.resolve();
    if (el && el._npDone) return Promise.reject(new Error('no-api'));
    return new Promise(function(ok, no){
      var fin = false, tm;
      function end(good, why){ if (fin) return; fin = true; clearTimeout(tm); good ? ok() : no(new Error(why)); }
      if (!el) {
        el = document.createElement('script');
        el.src = root.getAttribute('data-src'); el.async = true;
        el.addEventListener('load', function(){ this._npDone = true; });
        document.head.appendChild(el);
      }
      var me = el;
      me.addEventListener('load', function(){ end(!!(window.YQV5 && window.YQV5.trackSingle), 'no-api'); });
      me.addEventListener('error', function(){ if (me.parentNode) me.parentNode.removeChild(me); if (el === me) el = null; end(false, 'blocked'); });
      tm = setTimeout(function(){ end(false, 'timeout'); }, 6000);
    });
  }

  var seq = 0;
  function track(num, c){
    var my = ++seq;
    clearMsg(); clearOut(); busy(true);
    load17().then(function(){
      if (my !== seq) return;
      showResult(num, c);
      window.YQV5.trackSingle({ YQ_ContainerId: box.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
      if (!box.querySelector('iframe')) throw new Error('no-frame');
      go(res);
    }).catch(function(){
      if (my !== seq) return;
      res.hidden = true; box.innerHTML = '';
      showAlt(num, c); go(alt);
    }).then(function(){ if (my === seq) busy(false); });
  }
  function reset(focus){
    seq++; busy(false); clearMsg(); clearOut(); input.value = ''; guess(null);
    if (focus) { go(card); input.focus({ preventScroll: true }); }
  }
  function openWp(on){
    wpBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); wp.hidden = !on;
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var r = classify(input.value);
    if (r.k !== 'ok') { clearOut(); say(r.k); return; }
    input.value = r.num; guess(r.c);
    track(r.num, r.c);
  });
  input.addEventListener('input', function(){
    clearMsg();
    var r = classify(input.value);
    guess(r.k === 'ok' ? r.c : null);
  });
  wpBtn.addEventListener('click', function(){ openWp(wpBtn.getAttribute('aria-expanded') !== 'true'); });
  msg.addEventListener('click', function(e){
    if (!e.target.closest('[data-npp-tk-open-wp]')) return;
    openWp(true); go(wp); wp.focus({ preventScroll: true });
  });
  /* "Track another number" (resultado, plano B) e "Track a second number" (perguntas): limpa e volta ao campo */
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-npp-tk-again]');
    if (!a) return;
    e.preventDefault(); reset(true);
  });

  /* link do e-mail de envio: #nums=… (o fragmento nem chega ao servidor) ou ?nums= / ?tracking= → só preenche */
  try {
    var q = new URLSearchParams(location.search), h = new URLSearchParams(location.hash.replace(/^#/, '')),
        v = h.get('nums') || q.get('nums') || q.get('tracking');
    if (v) {
      q.delete('nums'); q.delete('tracking');
      var s = q.toString();
      history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + (h.get('nums') ? '' : location.hash));
      var r0 = classify(v);
      if (r0.k === 'ok') { input.value = r0.num; guess(r0.c); }
    }
  } catch (err) {}

  /* para o seletor de estados da prévia (e para testes): sem efeito na loja */
  root.nppTk = { classify: classify, guess: guess, say: say, busy: busy, showResult: showResult, showAlt: showAlt, openWp: openWp, reset: reset, carriers: CARRIERS };
})();
